import * as React from 'react';
import { RecentlyViewedProducts as RecentlyViewedProducts$1 } from '@grandvisionhq/products';
import { compose } from '@grandvisionhq/utils';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withAnchor } from '../../hocs/with-anchor.js';
import { useBrPageContext } from '../../context/context.js';
import { useBloomreachSiteLogos } from '../../hooks/use-bloomreach-site-logos.js';

const CmsRecentlyViewedProducts = ()=>{
    const siteLogos = useBloomreachSiteLogos();
    const page = useBrPageContext();
    return /*#__PURE__*/ React.createElement(RecentlyViewedProducts$1, {
        reimbursableLogos: {
            default: siteLogos.reimbursable,
            alternative: siteLogos.reimbursableAlternative
        },
        renderLocation: page === null || page === void 0 ? void 0 : page.getComponent().getName()
    });
};
var RecentlyViewedProducts = compose(withBreakpointVisibility, withAnchor)(CmsRecentlyViewedProducts);

export { CmsRecentlyViewedProducts, RecentlyViewedProducts as default };
//# sourceMappingURL=RecentlyViewedProducts.js.map
